import React from "react";

export default function Footer() {
  return (
    <footer>
      <p>
        This site is created solely for my learning!... It does not offer
        any real products or services. But, maybe you can still send in a little cash. yeah?... LOL
      </p>
      <p>&copy; david_agbemuko 2025</p>
    </footer>
  );
}
